import axios from 'axios'
import * as types from "../mutation-type"
import $httpService from '../../common/utils'

export default {
  state: {
    addressAnalytics: {
      info: ''
    },
    addressTokenAnalytics: {
      info: ''
    },
    scAnalytics: {
      info: ''
    },
    scTokenAnalytics: {
      info: ''
    },
    tokenAnalytics: {
      info: ''
    }
  },
  mutations: {
    [types.SET_ADDRESS_ANALYTICS](state, payload) {
      state.addressAnalytics.info = payload.info
    },
    [types.SET_ADDRESS_TOKEN_ANALYTICS](state, payload) {
      state.addressTokenAnalytics.info = payload.info
    },
    [types.SET_SC_ANALYTICS](state, payload) {
      state.scAnalytics.info = payload.info
    },
    [types.SET_SC_TOKEN_ANALYTICS](state, payload) {
      state.scTokenAnalytics.info = payload.info
    },
    [types.SET_TOKEN_ANALYTICS](state, payload) {
      state.tokenAnalytics.info = payload.info
    }
  },
  actions: {
    getaddressAnalytics({dispatch, commit},$param) {

      return $httpService.get('/addresses/'+$param.address+'/daily?token='+$param.analyticsType+'&from&to').then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_ADDRESS_ANALYTICS,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getaddressTokenAnalytics({dispatch, commit},$param) {
      let analyticsType
      if($param.analyticsType === "tx"){
        analyticsType = "native"
      }else{
        analyticsType = $param.analyticsType
      }
      return $httpService.get('/addresses/'+$param.address+'/'+analyticsType+'/daily?from&to').then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_ADDRESS_TOKEN_ANALYTICS,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getscAnalytics({dispatch, commit},$param) {

      return $httpService.get('/contracts/'+$param.contractHash+'/daily?token='+$param.analyticsType+'&from&to').then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_SC_ANALYTICS,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getscTokenAnalytics({dispatch, commit},$param) {
      let analyticsType
      if($param.analyticsType === "tx"){
        analyticsType = "native"
      }else{
        analyticsType = $param.analyticsType
      }

      return $httpService.get('/contracts/'+$param.contractHash+'/'+analyticsType+'/daily?from&to').then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_SC_TOKEN_ANALYTICS,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    gettokenAnalytics({dispatch, commit},$param) {
      return $httpService.get(`/tokens/${$param.contractType}/`+$param.contractHash+'/daily?from&to').then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_TOKEN_ANALYTICS,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js